const API_URL = import.meta.env?.VITE_API_URL ?? "";

export async function fetchMenu() {
  const res = await fetch(`${API_URL}/api/menu`);
  if (!res.ok) throw new Error("Failed to load menu");
  return res.json();
}

export async function submitOrder(data: {
  customer_name: string;
  customer_email: string;
  customer_phone: string;
  menu_item_id: number | null;
  item_name: string;
  pickup_date: string;
  notes: string;
}) {
  const res = await fetch(`${API_URL}/api/orders`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as any).error ? "Invalid order data" : `Request failed: ${res.status}`);
  }
  return res.json();
}
